<template>
  <div>
    <div
      class="modal animated fadeIn"
      id="weeklyexpensesModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content">
          <div class="modal-body">
            <fieldset class="border p-3">
              <legend>
                <small style="font-size: 15px; font-weight: bold"
                  >Product purchases</small
                >
              </legend>
              <form @submit.prevent="loadproductPurchases()">
                <div class="row">
                  <input type="hidden" class="product_id" :value="Product.id" />
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>From date</label>
                      <input
                        type="date"
                        class="form-control from_date"
                        placeholder="daily expenses date"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>End date</label>
                      <input
                        type="date"
                        class="form-control end_date"
                        placeholder="daily expenses date"
                        required
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3">
                    <button
                      type="button"
                      class="btn btn-danger btn-flat"
                      data-dismiss="modal"
                    >
                      <i class="fa fa-times"></i> Cancel
                    </button>
                  </div>
                  <div class="col-md-3">
                    <button
                      type="submit"
                      class="btn btn-primary btn-flat creatingProductpurchases"
                    >
                      <i class="fa fa-file-pdf-o"></i> Print
                    </button>
                    <button
                      type="button"
                      class="btn btn-primary btn-flat creatingProductpurchasesLoader"
                    >
                      <span
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <i
                        class="fa fa-spinner fa-spin"
                        style="font-size: 24px"
                      ></i>
                      please wait...
                    </button>
                  </div>
                </div>
              </form>
            </fieldset>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal animated fadeIn"
      id="fullweeklyexpensesModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content">
          <div class="modal-body">
            <fieldset class="border p-3">
              <legend>
                <small style="font-size: 15px; font-weight: bold"
                  >Product purchases</small
                >
              </legend>
              <form @submit.prevent="loadfullPurchases()">
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>From date</label>
                      <input
                        type="date"
                        class="form-control full_from_date"
                        placeholder="daily expenses date"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>End date</label>
                      <input
                        type="date"
                        class="form-control full_end_date"
                        placeholder="daily expenses date"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Days</label>
                      <input
                        type="number"
                        class="form-control day_out"
                        required
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3">
                    <button
                      type="button"
                      class="btn btn-danger btn-flat"
                      data-dismiss="modal"
                    >
                      <i class="fa fa-times"></i> Cancel
                    </button>
                  </div>
                  <div class="col-md-3">
                    <button
                      type="submit"
                      class="btn btn-primary btn-flat creatingFullpurchases"
                    >
                      <i class="fa fa-file-pdf-o"></i> Print
                    </button>
                    <button
                      type="button"
                      class="btn btn-primary btn-flat creatingFullpurchasesLoader"
                    >
                      <span
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <i
                        class="fa fa-spinner fa-spin"
                        style="font-size: 24px"
                      ></i>
                      please wait...
                    </button>
                  </div>
                </div>
              </form>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
    <div class="separator-breadcrumb border-top"></div>
    <div class="row">
      <div class="col-md-12">
        <div class="card mb-4">
          <div class="card-body">
            <div class="card-title mb-3">Manage product purchases</div>
            <fieldset class="border p-3">
              <button
                type="button"
                class="btn btn-success btn-roundec"
                data-toggle="modal"
                data-target="#fullweeklyexpensesModal"
              >
                <i class="fa fa-file-pdf-o"></i> General purchases
              </button>
              <p></p>
              <div></div>
              <div>
                <div class="productsLoader">
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <i
                    class="fa fa-spinner fa-spin"
                    style="font-size: 24px; color: blue"
                  ></i
                  >loading products...
                </div>
                <vue-good-table
                  :columns="columns"
                  :rows="systemProducts"
                  :fixed-header="true"
                  :pagination-options="{
                    enabled: true,
                    mode: 'records',
                    perPage: 6,
                    position: 'bottom',
                    perPageDropdown: [3, 7, 9],
                    dropdownAllowAll: false,
                    setCurrentPage: 1,
                    nextLabel: 'next',
                    prevLabel: 'prev',
                    rowsPerPageLabel: 'Rows per page',
                    ofLabel: 'of',
                    pageLabel: 'page', // for 'pages' mode
                    allLabel: 'All',
                  }"
                >
                  <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field == 'Action'">
                      <button
                        type="button"
                        class="btn btn-primary btn-roundec"
                        data-toggle="modal"
                        data-target="#weeklyexpensesModal"
                        @click="viewProducts(props.row.id)"
                      >
                        <i class="fa fa-file-pdf-o"></i> Product purchases
                      </button>
                    </span>
                  </template>
                </vue-good-table>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          label: "Product number",
          field: "product_number",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter prod number",
          },
        },
        {
          label: "Product name",
          field: "product_name",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter prod name",
          },
        },
        {
          label: "Product description",
          field: "product_description",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter prod description",
          },
        },
        {
          label: "measurement",
          field: "product_measurement",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter prod measurement",
          },
        },
        {
          label: "Buying price",
          field: "buying_price",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter buying price",
          },
        },
        {
          label: "Selling price",
          field: "selling_price",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter selling price",
          },
        },
        {
          label: "Action",
          field: "Action",
          width: "122px",
          html: true,
        },
      ],
    };
  },
  created() {
    this.loadProduct();
  },
  computed: {
    ...mapGetters(["systemProducts", "Product"]),
  },
  methods: {
    ...mapActions([
      "loadProduct",
      "viewProducts",
      "loadproductPurchases",
      "loadfullPurchases",
    ]),
  },
};
</script>
<style scoped>
.creatingProductpurchasesLoader {
  display: none;
}
.creatingFullpurchasesLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/reports/productpurchases.vue